import { IStoreUser } from 'AppTypes'

export class StoreUser implements IStoreUser {
  id: string

  userId?: string

  userName?: string

  email: string

  fullName?: string

  status?: number

  roles?: string[]

  storeIds?: string[]

  note?: string

  jwtToken?: string

  refreshToken?: string

  constructor (user: IStoreUser) {
    this.id = user.id
    this.userId = user.userId
    this.userName = user.userName
    this.email = user.email
    this.fullName = user.fullName
    this.status = user.status
    this.roles = user.roles
    this.storeIds = user.storeIds || []
    this.note = user.note
    this.jwtToken = user.jwtToken
    this.refreshToken = user.refreshToken
  }

  get statusTxt (): string {
    return 'active'
  }

  get currentStoreId (): string {
    const currentStoreIdFromLocalStorage = localStorage.getItem('currentStoreId') || ''

    if ((this.storeIds || []).length && this.storeIds?.includes(currentStoreIdFromLocalStorage))
      return currentStoreIdFromLocalStorage

    return (this.storeIds || [])[0] || ''
  }

  isStoreSeniorManager (): boolean {
    if (!this.roles || !this.roles.length) return false
    return this.roles.includes('StoreSeniorManager')
  }

  isStoreManager (): boolean {
    if (!this.roles || !this.roles.length) return false
    return this.roles.includes('StoreSeniorManager') || this.roles.includes('StoreManager')
  }
}
